import TransferenciaRepasses from './TransferenciaRepasses';

export default TransferenciaRepasses;
